import {Controller} from "@hotwired/stimulus";
import SignaturePad from "signature_pad";

export default class extends Controller {
    static targets = ["canvas", "input", "img", "encrypted"];

    signaturePad;

    async connect() {
        if (this.hasEncryptedTarget && this.hasImgTarget) {
            try {
                const encrypted = this.encryptedTarget.getAttribute("data-value");
                if (!encrypted) return;

                if (!window.vault || !window.vault.is_open()) {
                    return;
                }

                const dataUri = await window.vault.decryptMessage(encrypted);
                if (dataUri) this.imgTarget.src = dataUri;
            } catch (e) {
                console.log("Signature preview failed:", e);
            }
            return;
        }

        if (!this.hasCanvasTarget) return;

        const compStyles = window.getComputedStyle(this.canvasTarget);
        this.canvasTarget.width = parseFloat(compStyles.width);
        this.canvasTarget.height = parseFloat(compStyles.height);

        this.signaturePad = new SignaturePad(this.canvasTarget);
        this.signaturePad.clear();
    }

    disconnect() {
        this.element.removeEventListener('submit', this.clearOnSubmit.bind(this));
    }

    clear() {
        this.signaturePad?.clear();
        if (this.hasInputTarget) this.inputTarget.value = "";
    }

    save() {
        if (!this.signaturePad) return;

        if (!this.signaturePad.isEmpty()) {
            this.inputTarget.value = this.signaturePad.toDataURL("image/png");
        } else {
            alert("Please sign before saving.");
        }
    }

    clearOnSubmit(event) {
        this.clear();
    }
}
